import { createPostEndpoint } from '@sonar-software/sonar-http';
import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

export type PostAccessLogExportRequest = DynamicQueryParams;

export type PostAccessLogExportResponse = { id: number };

export const postAccessLogExportStart = createPostEndpoint<PostAccessLogExportRequest, PostAccessLogExportResponse>(
	'/api/v3/core/exports/access-log/export/start'
);
